const ENABLED_CATEGORY_IDS = [51163, 51164];

const shouldShowNewInTodayRibbon = ({
  loyaltyIsEnabled,
  loyaltyIsOptedIn,
  categoryId
}) =>
  loyaltyIsEnabled &&
  ENABLED_CATEGORY_IDS.includes(categoryId) &&
  loyaltyIsOptedIn;

export default shouldShowNewInTodayRibbon;
